import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import useBodyBackgroundColor from 'hooks/useBodyStyle';
import { ColorsName } from 'styles/theme';

interface Props {
  leftContent: ReactNode;
  rightContent: ReactNode;
  showRightSideOnMobile?: boolean;
  rightSideBackgroundColor?: ColorsName;
  className?: string;
}

const Split: FC<Props> = ({
  rightContent,
  leftContent,
  showRightSideOnMobile,
  className,
  rightSideBackgroundColor,
}) => {
  useBodyBackgroundColor('contentBackground');

  return (
    <SplitWrapper showRightSideOnMobile={showRightSideOnMobile} className={className}>
      <LeftSide>{leftContent}</LeftSide>
      <RightSide showRightSideOnMobile={showRightSideOnMobile} backgroundColor={rightSideBackgroundColor}>
        {rightContent}
      </RightSide>
    </SplitWrapper>
  );
};

const SplitWrapper = styled.div<{ showRightSideOnMobile?: boolean }>`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.large}) {
    position: relative;
    height: auto;
    width: auto;

    ${({ showRightSideOnMobile }) =>
      showRightSideOnMobile &&
      `
    flex-direction: column;
  `}
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 300ms all;
  z-index: 100;
`;

const LeftSide = styled.div`
  display: flex;
  height: 100%;
  flex: 1 1 calc((100% / 3) * 2);
  align-items: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    align-items: flex-start;
    padding-top: ${({ theme }) => theme.paddings.massive};
  }
  justify-content: center;
  position: relative;
  padding: ${({ theme }) => theme.paddings.extraLarge};
`;

const RightSide = styled.div<{ showRightSideOnMobile?: boolean; backgroundColor?: ColorsName }>`
  display: flex;
  height: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.large}) {
    display: ${({ showRightSideOnMobile }) => !showRightSideOnMobile && 'none'};
  }
  flex: 1 1 calc(100% / 3);
  align-items: center;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? theme.color[backgroundColor] : theme.color.bodyBackground};
  flex-direction: column;
`;

export default Split;
